export default {
  namespaced: true,
  state: {
    id: 0,
    account: '',
    name: '',
    bankId: 0,
    bankName: '',
    bankLevel: 0,
    bankType: '',
    isFirstLogin: null,
    token:'',
    username:'',
    areaId: '',
    projectId: undefined
  },
  mutations: {
    updateId (state, id) {
      state.id = id
    },
    updateAccount (state, account) {
      state.account = account
    },
    updateName (state, name) {
      state.name = name
    },
    updateBankId (state, bankId) {
      state.bankId = bankId
    },
    updateBankName (state, bankName) {
      state.bankName = bankName
    },
    updateBankLevel (state, bankLevel) {
      state.bankLevel = bankLevel
    },
    updateBankType (state, value) {
      state.bankType = value
    },
    updateIsFirstLogin(state, isFirstLogin){
      state.isFirstLogin = isFirstLogin
    },
    updateToken(state, token){
      state.token = token
    },
    updateUsername(state, username){
      state.username = username
    },
    updateAreaId(state, areaId){
      state.areaId = areaId
    },
    updateProjectId(state, value) {
      state.projectId = value
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js